import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { apiPostAuth } from "../utils/api";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated , setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      
      try{
        const response = await apiPostAuth("is_logged_in.php");
        if(response.status === "error"){
          setIsAuthenticated(false);
        }else{
          setIsAuthenticated(true);
        }
        setLoading(false);
      }catch(error){
        
      }
    };
    verifyEmail();
  }, []);

  if (loading) return <div>Loading...</div>;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;
